import { Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import { useFinancialStatus } from "../../hooks/FinancialStatusContext";
import { roles } from "../../utils/constants";
import LayoutIframe from "../LayoutIframe";
import OverduePayment from "../OverduePaymentPage";

export function PaymentGuardLayout() {
  const { user } = useAuth();
  const { isOverdue, isLoading } = useFinancialStatus();

  if (user?.role !== roles.licensee) {
    return <Outlet />;
  }

  if (isLoading) return <div>Verificando status...</div>;
  if (isOverdue) return <LayoutIframe><OverduePayment /></LayoutIframe>;

  return <Outlet />;
}
